'use client';

import { Button, Icon } from '@/components/ui';
import { cn } from '@/libs';

type PrizesNavigationProps = {
  currentIndex: number;
  totalPrizes: number;
  canGoNext: boolean;
  canGoPrev: boolean;
  onNext: () => void;
  onPrev: () => void;
  showButtons?: boolean;
  className?: string;
};

export const PrizesNavigation = ({
  currentIndex,
  totalPrizes,
  canGoNext,
  canGoPrev,
  onNext,
  onPrev,
  showButtons = true,
  className,
}: PrizesNavigationProps) => {
  return (
    <div className={cn('flex items-center justify-between', className)}>
      <div className="flex items-center space-x-2">
        <span className="text-sm text-foreground/60">
          {currentIndex + 1} de {totalPrizes}
        </span>
      </div>

      {showButtons && (
        <div className="flex items-center space-x-2">
          <Button
            variant="ghost"
            size="small"
            onClick={onPrev}
            disabled={!canGoPrev}
            className={cn(
              'flex items-center justify-center w-8 h-8 rounded-full',
              'bg-foreground/10 hover:bg-foreground/20 transition-colors',
              'disabled:opacity-50 disabled:cursor-not-allowed',
            )}
            aria-label="Prêmio anterior"
          >
            <Icon.ChevronLeft width={16} height={16} />
          </Button>

          <Button
            variant="ghost"
            size="small"
            onClick={onNext}
            disabled={!canGoNext}
            className={cn(
              'flex items-center justify-center w-8 h-8 rounded-full',
              'bg-foreground/10 hover:bg-foreground/20 transition-colors',
              'disabled:opacity-50 disabled:cursor-not-allowed',
            )}
            aria-label="Próximo prêmio"
          >
            <Icon.ChevronRight width={16} height={16} />
          </Button>
        </div>
      )}
    </div>
  );
};
